const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const URLMake = require("../../../shared/URLMake");
const BookstoreUtil = require("../../../shared/BookstoreUtil");
const ApparelUtil = require("../../core/util/ApparelUtil");
const AssetsUtil = require("../../core/util/AssetsUtil");
const Link = require("../../core/view/Link");
const ComputerScreenshot = require("../../core/view/ComputerScreenshot");

const styles = require("./styles/CartItemIcon.css");

const isScienceSet = itemDetails =>
	itemDetails.isFullSet === true &&
	_.every(itemDetails.books, book => book.sku.includes("science"));

module.exports = createReactClass({
	displayName: "CartItemIcon",

	propTypes: {
		// We can add more to this as we get more items
		itemType: PT.oneOf([
			"book",
			"subscription",
			"bundle",
			"apparel",
			"code",
			"gift",
		]).isRequired,
		itemDetails: PT.object,
		className: PT.string,
		isSmall: PT.bool,
		hideGrade: PT.bool,
	},

	render: function() {
		const {itemType, itemDetails, className, isSmall, hideGrade} = this.props;
		let mainClass = isSmall ? styles.mainSmall : styles.main;
		if (itemType === "bundle" && isSmall) {
			mainClass = styles.mainBundleSmall;
		}
		if (className) mainClass += " " + className;

		let labelClass;
		let linkTo;

		if (itemDetails && itemDetails.isFullSet && isScienceSet(itemDetails)) {
			const {grade} = itemDetails;
			linkTo = URLMake.forScienceBookLevel(grade);
			return (
				<Link to={linkTo} className={mainClass}>
					<img
						className={styles.bundleBooksLarge}
						alt={"Level " + grade + " science books"}
						src={`/assets/wf/images/level${grade}_science_books.png`}
					/>
				</Link>
			);
		} else if (itemDetails && itemDetails.isFullSet) {
			const {grade} = itemDetails;
			linkTo = URLMake.forBookLevel(grade);
			return (
				<Link to={linkTo} className={mainClass}>
					<img
						className={styles.bundleBooksLarge}
						alt={"Level " + grade + " books"}
						src={`/assets/wf/images/level${grade}_books.png`}
					/>
				</Link>
			);
		} else if (itemType === "book") {
			const {bookHash, type} = itemDetails;
			const nameText = bookHash + " " + _.capitalize(type);
			const grade = BookstoreUtil.getGradeFromHash(bookHash);

			const coverClass = isSmall ? styles.smallCover : styles.cover;
			if (BookstoreUtil.isScienceBook(bookHash)) {
				labelClass = styles["label" + grade + "s"];
				linkTo = URLMake.forScienceBook(bookHash);
			} else {
				labelClass = styles["label" + grade];
				linkTo = URLMake.forBook(bookHash);
			}

			const labelContents = BookstoreUtil.isPuzzleBook(bookHash) ? (
				<img
					className={styles.puzzleImage}
					src={AssetsUtil.getPuzzlePiece("white")}
				/>
			) : (
				<div>{bookHash}</div>
			);

			return (
				<Link to={linkTo} className={mainClass}>
					<img
						className={coverClass}
						alt={nameText}
						src={BookstoreUtil.getBookCoverSrc(
							bookHash,
							type === "practice",
							"tiny"
						)}
					/>
					<div className={labelClass}>{labelContents}</div>
				</Link>
			);
		} else if (
			itemType === "subscription" ||
			itemType === "code" ||
			itemType === "gift"
		) {
			if (itemType === "code") {
				linkTo = URLMake.forSaveWithFriends();
			} else if (itemType === "gift") {
				linkTo = URLMake.forGifting();
			} else {
				linkTo = URLMake.forBAOnline();
			}
			mainClass += " " + styles.mainAlt;
			return (
				<Link to={linkTo} className={mainClass}>
					<ComputerScreenshot
						screenshotType={"home-page-tiny"}
						alt={"Beast Academy online"}
						computerType={"laptop-black"}
						className={styles.onlineLaptop}
					/>
				</Link>
			);
		} else if (itemType === "bundle") {
			const {level} = itemDetails;
			labelClass = hideGrade ? styles.hidden : styles["bundleLabel" + level];
			mainClass += " " + styles.mainAlt;
			linkTo = URLMake.forBAOnline();
			return (
				<Link to={linkTo} className={mainClass}>
					<img
						className={
							level === 1 ? styles.bundleBooksLarge : styles.bundleBooks
						}
						alt={"Level " + level + "books"}
						src={BookstoreUtil.getBundleCovers(level)}
					/>
					<ComputerScreenshot
						screenshotType={"home-page-tiny"}
						alt={"Beast Academy online"}
						computerType={"laptop-black"}
						className={styles.bundleLaptop}
					/>
					<div className={labelClass}>{level}</div>
				</Link>
			);
		} else if (itemType === "apparel") {
			const {apparelHash, apparelName} = itemDetails;
			linkTo = URLMake.forApparel(apparelHash);

			return (
				<Link to={linkTo} className={mainClass}>
					<img
						className={styles.apparel}
						alt={apparelName}
						src={ApparelUtil.getApparelImageSrc(apparelHash, true, "tiny")}
					/>
				</Link>
			);
		} else {
			return null;
		}
	},
});
